import Cookies from "js-cookie";
import * as CONSTANTS from "./shared/constants";
import { COOKIE_PREFIX, COOKIE_DOMAIN } from "src/environments/environment";

export class CookiesService {
  public static domain = COOKIE_DOMAIN;

  public static getUserLogged(): boolean {
    return JSON.parse(Cookies.get(`${COOKIE_PREFIX}${CONSTANTS.COOKIE_USER_LOGGED}`))
  }
  public static getUserAvatar(): string {
    return Cookies.get(`${COOKIE_PREFIX}${CONSTANTS.COOKIE_USER_AVATAR}`);
  }
  /**
   * user types: 'user' | 'artist' | 'admin'
   */
  public static getUserType(): string {
    return Cookies.get(`${COOKIE_PREFIX}${CONSTANTS.COOKIE_USER_TYPE}`);
  }
  public static setUserLogged(value: boolean) {
    Cookies.set(
      `${COOKIE_PREFIX}${CONSTANTS.COOKIE_USER_LOGGED}`,
      JSON.stringify(value),
      {
        domain: CookiesService.domain,
        expires: 365,
      }
    );
  }
  public static setUserAvatar(value: string) {
    Cookies.set(`${COOKIE_PREFIX}${CONSTANTS.COOKIE_USER_AVATAR}`, value, {
      domain: CookiesService.domain,
      expires: 365,
    });
  }
  public static setUserType(value: string) {
    Cookies.set(`${COOKIE_PREFIX}${CONSTANTS.COOKIE_USER_TYPE}`, value, {
      domain: CookiesService.domain,
      expires: 365,
    });
  }
  public static deleteAllCookies() {
    const cookieNames = Cookies.get();
    Object.keys(cookieNames).forEach((key) => {
      if (key.startsWith(COOKIE_PREFIX)) {
        Cookies.remove(key);
      }
    });
  }
  public static initCookies() {
    this.setUserAvatar("");
    this.setUserType("");
    this.setUserLogged(null);
  }

  public static setItem(key, value) {
    Cookies.set(`${COOKIE_PREFIX}${key}`, value, {
      domain: CookiesService.domain,
      expires: 365,
    });
  }

  public static getItem(key) {
    return Cookies.get(`${COOKIE_PREFIX}${key}`)
      ? Cookies.get(`${COOKIE_PREFIX}${key}`)
      : null;
  }

  public static removeItem(key) {
    Cookies.remove(`${COOKIE_PREFIX}${key}`, {
      domain: CookiesService.domain,
    });
  }
  public static clear() {
    this.deleteAllCookies();
  }
}
